// eslint-disable-next-line import/no-extraneous-dependencies
import { isValid, parseISO } from 'date-fns';
var getISOStringToDate = function (isoString) {
    if (isoString && isValid(parseISO(isoString))) {
        var _a = isoString.split('T')[0].split('-'), year = _a[0], month = _a[1], day = _a[2];
        var dayNumber = Number(day);
        var monthNumber = Number(month);
        var yearNumber = Number(year);
        var date = new Date(yearNumber, monthNumber - 1, dayNumber);
        date.setFullYear(yearNumber); // for years before 1900
        return {
            date: date,
            day: dayNumber,
            month: monthNumber,
            year: yearNumber
        };
    }
    return { date: null };
};
export default getISOStringToDate;
//# sourceMappingURL=getISOStringToDate.js.map